import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify/lib'
import i18n from './i18n'
import '@/sass/overrides.scss'
import {moduleConfig} from '@/modules/core'

Vue.use(Vuetify)

const theme = {
  primary: '#005ce5',
  secondary: '#798EA4',
  accent: '#eff4fa',
  error: '#E94B3C',
  info: '#00758F',
  success: '#009B77',
  warning: '#FA7A35'
}

export default new Vuetify({
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  rtl: moduleConfig().shared.rtl,
  theme: {
    themes: {
      dark: theme,
      light: theme
    }
  }
})
